import React from 'react';

import { Editor } from '@tinymce/tinymce-react';

import TinyMCEConfig from '~/config/tiny-mce';

interface TinyMCEProps {
  config?: any | null;
  onInit: (evt: any, editor: any) => void;
}

const apiKey = '71qrpx1oa1w9poknx2qrlk6f2o30jpnb5vpdorx7vq0q6ou5';

function TinyMCE({ onInit, config = null }: TinyMCEProps) {
  return <Editor apiKey={apiKey} onInit={onInit} init={config || TinyMCEConfig} />;
}

export default TinyMCE;
